/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class CalloutDirective {
    public restrict = 'E';
    public scope = {};
    public template;
    public value;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            coIndex: '=',
            coLast: '=',
            coPermission: '@',
            coText: '@',
            coDir: '@',
            coOffset: '@',
            coCurrent: '=',
            nextStep: '&',
            endStep: '&',
            coTour: '=',
            coScroll: '=?'
        };

        this.template = `
            <div class="{{coDir}} {{co-offset}}", ng-if='coIndex == coCurrent'>
                <p>{{coText}}</p>
                <br>
                <div>
                    <md-button class=' br-normal md-primary md-raised m--0 br-reset md-callout-buttons', ng-click="next()", ng-if='!coLast && !coTour'>Next</md-button>
                    <md-button class=' br-normal md-primary md-raised m--0 br-reset md-callout-buttons', ng-click="next()", ng-if='coTour == true'>Next Tab</md-button>
                    <md-button class=' br-normal md-raised m--0 br-reset md-callout-buttons', ng-click="end()">Finish</md-button>
                    
                </div>
            </div>
        `;
    }

    public link($scope: any, $element: any, attrs: any): void { 
        $scope.$watch('coCurrent', function(): any {
            if ($scope.coIndex === $scope.coCurrent) {
                if ($scope.coPermission !== undefined) {
                    $scope.nextStep({args: $scope.coPermission});
                }
                if ($scope.coScroll !== undefined) {
                    $element[0].scrollIntoView(false);
                }
            } 
        });
        
        $scope.next = function(): any {
            let permission: string = 'all';
            $scope.nextStep({args: permission});           
        };

        $scope.end = function(): any {
            $scope.endStep();
        };
    }

    public static DirectiveFn($timeout: any): CalloutDirective {
        return new CalloutDirective($timeout);
    }
}

CalloutDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('callout', CalloutDirective.DirectiveFn);





// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/callout.directive.ts